"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Month = void 0;
const react_1 = __importStar(require("react"));
const DatetimeInputContext_1 = require("../../../controls/DatetimeInput/context/DatetimeInputContext");
const getDateWithOffset_1 = require("../../../controls/DatetimeInput/helpers/getDateWithOffset");
const helpers_1 = require("../../../helpers");
const MonthDayItem_1 = require("./components/MonthDayItem/MonthDayItem");
const MonthTitleWeek_1 = require("./components/MonthTitleWeek/MonthTitleWeek");
const Month_styles_1 = require("./Month.styles");
const MonthCalendarContext_1 = require("../../context/MonthCalendarContext");
const constants_1 = require("../../helpers/constants");
const CalendarWeeks_1 = require("../../types/CalendarWeeks");
exports.Month = (0, helpers_1.createUIElement)('Month', (_a, ref) => {
    var { className, year, month, value, hasStaticNumberOfWeek = true, onSelect, isDayDisabled, highlightDates = [], texts, showCurrentDate = true, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "year", "month", "value", "hasStaticNumberOfWeek", "onSelect", "isDayDisabled", "highlightDates", "texts", "showCurrentDate", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    const uiTexts = (0, react_1.useMemo)(() => {
        return Object.assign(Object.assign({}, constants_1.DEFAULT_TEXTS_MONTH), texts);
    }, [texts]);
    const weekStartDay = (0, react_1.useContext)(MonthCalendarContext_1.MonthCalendarContext).weekStartDay;
    const weeks = (0, react_1.useMemo)(() => new CalendarWeeks_1.CalendarWeeks(year, month, weekStartDay, hasStaticNumberOfWeek).getDatesGroupedByWeek(), [hasStaticNumberOfWeek, month, weekStartDay, year]);
    const context = (0, react_1.useContext)(DatetimeInputContext_1.DatetimeInputContext);
    const now = (context === null || context === void 0 ? void 0 : context.getNowTime)
        ? context === null || context === void 0 ? void 0 : context.getNowTime()
        : (0, getDateWithOffset_1.getDateWithOffset)(new Date(), context.serverUtcOffset);
    const highlightDays = (0, react_1.useMemo)(() => highlightDates.map((highlightDate) => highlightDate.toDateString()), [highlightDates]);
    return (react_1.default.createElement(Month_styles_1.StyledMonth, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": rest['data-selector-id'], onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-Month', className) }),
        react_1.default.createElement(MonthTitleWeek_1.MonthTitleWeek, { firstWeekDay: weekStartDay, uiTexts: uiTexts }),
        weeks.map((dates, weekIndex) => (react_1.default.createElement(Month_styles_1.StyledMonthWeek, { key: `month-week-${weekIndex}` }, dates.map((date, dateIndex) => {
            return (react_1.default.createElement(MonthDayItem_1.MonthDayItem, { key: `month-week-${weekIndex}-day-${dateIndex}`, value: value, date: date, highlightDays: highlightDays, now: now, year: year, month: month, onSelect: onSelect, isDayDisabled: isDayDisabled, showCurrentDate: showCurrentDate }));
        }))))));
});
//# sourceMappingURL=Month.js.map